import { isMobile } from '../refresh/utils/deviceTypeUtils';

const COMPANION_STORAGE_KEY = 'companion_flow_data';
const COMPANION_SESSION_KEY = 'companion_session';

// Check if session is present then only rest of the feature will work
export const isCompanionSessionActive = () => {
  return !!sessionStorage.getItem(COMPANION_SESSION_KEY);
};

// Start the session if we come from Companion APP
export const startCompanionSession = () => {
  sessionStorage.setItem('is_companion_flow', true);
  sessionStorage.setItem(COMPANION_SESSION_KEY, 'active');
};

// Update SkuID if user changes size from cart
export const updateCompanionSkuIfRequired = (oldSkuId, newSkuId) => {
  if (!isCompanionSessionActive()) return;
  const storedData = JSON.parse(localStorage.getItem(COMPANION_STORAGE_KEY) || '{}');

  if (!storedData.products || !storedData.products[oldSkuId]) return;

  const productMeta = storedData.products[oldSkuId];

  // Remove old SKU
  delete storedData.products[oldSkuId];

  // Add new SKU with same metadata
  storedData.products[newSkuId] = productMeta;

  localStorage.setItem(COMPANION_STORAGE_KEY, JSON.stringify(storedData));
};

// Delete Companion Product if removed from cart
export const removeCompanionProduct = skuId => {
  const storedData = JSON.parse(localStorage.getItem(COMPANION_STORAGE_KEY) || '{}');

  if (!storedData.products || !storedData.products[skuId]) return;

  delete storedData.products[skuId];
  const attemptKey = `companion_attempt_${skuId}`;
  sessionStorage.removeItem(attemptKey);
  // If no products left, clear entire object
  if (Object.keys(storedData.products).length === 0) {
    localStorage.removeItem(COMPANION_STORAGE_KEY);
  } else {
    localStorage.setItem(COMPANION_STORAGE_KEY, JSON.stringify(storedData));
  }
};

export const isCompanionProduct = productCode => {
  // const params = new URLSearchParams(window.location.search);
  // const utmSource = params.get('utm_source');
  const isMobileDevice = isMobile();
  if (!productCode || !isMobileDevice) return false;
  if (!isCompanionSessionActive()) return false;
  const storedData = JSON.parse(localStorage.getItem(COMPANION_STORAGE_KEY) || '{}');

  return storedData?.products?.[productCode] || null;
};

// For passing into payment for segment
export const getFullCompanionData = () => {
  try {
    const isMobileDevice = isMobile();
    if (!isCompanionSessionActive() && !isMobileDevice) return {};
    return JSON.parse(localStorage.getItem(COMPANION_STORAGE_KEY) || '{}');
  } catch {
    return {};
  }
};

// Not used
export const addCompanionSkuIfExists = (referenceSkuId, newSkuId) => {
  if (!isCompanionSessionActive()) return;
  const stored = localStorage.getItem(COMPANION_STORAGE_KEY);
  if (!stored) return;

  const data = JSON.parse(stored);
  if (data.products && data.products[referenceSkuId] && !data.products[newSkuId]) {
    data.products[newSkuId] = data.products[referenceSkuId];

    localStorage.setItem(COMPANION_STORAGE_KEY, JSON.stringify(data));
  }
};

// Remove all the key with companion attempts
export const clearAllCompanionAttempts = () => {
  Object.keys(sessionStorage)?.forEach(key => {
    if (key?.startsWith('companion_attempt_')) {
      sessionStorage.removeItem(key);
    }
  });
};
